/**
 * Created by Federico Brocco on 30/08/2023.
 *
 * @format
 */

////////////////////
// PER MODULI ONLINE
////////////////////

/**
 * Recupera l'elenco dei moduli online disponibili (attualmente restituisce un array vuoto)
 * @returns {Promise<Array>} Promise che risolve con un array vuoto
 */
let list = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        resolve([])

        // fetch(window.route.messageTicket + window.getMunicipalityString(), {
        //     headers: {'x-access-token': hash},
        //     method: 'GET'
        // })
        //     .then((response) => (response.status !== 500) ? response.json() : reject())
        //     .then((responseJson) => {
        //         console.log('API ticket messages', responseJson.messages);
        //         resolve(responseJson.messages);
        //     })
        //     .catch((e) => {
        //         console.error(e.message);
        //         reject()
        //     });
    });
};

/**
 * Recupera l'elenco dei moduli inviati dall'utente autenticato
 * @returns {Promise<Array>} Promise che risolve con un array di moduli inviati
 */
let sentList = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.sentsModules, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API modules sent', responseJson);
                resolve(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Invia un modulo compilato al server
 * @param {Object} module - I dati del modulo da inviare
 * @param {string|number} module.id - L'ID del tipo di form
 * @param {string} module.name - Il nome del file caricato
 * @param {string} module.file - Il file codificato in base64
 * @returns {Promise<Object>} Promise che risolve con la risposta del server
 */
let send = function (module) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        // Debug: log del payload completo
        const payload = {
            id_form_type: module.id,
            name_file_uploaded: module.name,
            file_uploaded: module.file,
            tipo_descrizione: module.tipo_descrizione,
            body_richiesta: module.body_richiesta
        };
        console.log('Payload completo da inviare all\'API:', payload);
        console.log('Body richiesta presente?', !!module.body_richiesta);

        fetch(window.route.sendModule, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then((response) => {
                if (response.status === 401) {
                    reject(new Error('Non autorizzato. Effettua il login.'));
                    return;
                }
                if (!response.ok) {
                    return response.json().then(error => {
                        reject(new Error(error.error || 'Errore del server'));
                    });
                }
                return response.json();
            })
            .then((responseJson) => {
                if (responseJson) {
                    console.log('API send module', responseJson);
                    resolve(responseJson);
                }
            })
            .catch((e) => {
                console.error('Errore chiamata API:', e);
                reject(e);
            });
    });
};

/**
 * Aggiunge un allegato a un modulo esistente
 * @param {Object} attachment - I dati dell'allegato da aggiungere
 * @param {string|number} attachment.formId - L'ID del form esistente
 * @param {string} attachment.name - Il nome del file da allegare
 * @param {string} attachment.file - Il file codificato in base64
 * @returns {Promise<Object>} Promise che risolve con la risposta del server
 */
let addAttachment = function (attachment) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        const payload = {
            form_id: attachment.formId,
            name_file_uploaded: attachment.name,
            file_uploaded: attachment.file
        };
        console.log('Aggiunta allegato a form esistente:', payload.form_id, payload.name);

        fetch(window.route.sendModule, {
            headers: {
                'x-access-token': hash,
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then((response) => {
                if (response.status === 401) {
                    reject(new Error('Non autorizzato. Effettua il login.'));
                    return;
                }
                if (!response.ok) {
                    return response.json().then(error => {
                        reject(new Error(error.error || 'Errore del server'));
                    });
                }
                return response.json();
            })
            .then((responseJson) => {
                if (responseJson) {
                    console.log('Allegato aggiunto con successo', responseJson);
                    resolve(responseJson);
                }
            })
            .catch((e) => {
                console.error('Errore aggiunta allegato:', e);
                reject(e);
            });
    });
};



const ModulesAPI = {
    list: list,
    send: send,
    sentList: sentList,
    addAttachment: addAttachment
};

export default ModulesAPI;
